module.exports = __webpack_public_path__ + "img/zk-icon-spell-group.1b48c848.svg";